export const environment = {
    production: false,
    productName: "Invictus",
    errMsg: 'Failed to complete. Please try again.',
    partner: false,
    multiregion: false,
    regions: [{
        regionId: "1",
        regionCode: "NA",
    }],
    config: {
        "haystackUrl": "https://silo.dev.service.75f.io/",
        "auth": {
            "caretakerUrl": "https://caretaker.dev.service.75f.io/api/v1"
        },
        "edgeRunnerApi": "https://micropython-edge-api.azurewebsites.net/",
        'devCycleClientId':"dvc_client_a4749bbe_7e11_45e9_9d12_ac5d30d39aea_503e9e6",
        "externalServices": "https://external-services.dev.service.75f.io/",
        "userTractionUrl": "https://user-traction.dev.service.75f.io/",
        "helpCenter": "https://support.75f.io",
        "partnerName": "75F",
        "klipyApiKey": 'chJg8W90GkVk6F4D0hic2iJA3IKcyN2ihgHjqNEA3LMLXG6CL6GhwkZ3FExFBa3u',
        "1":{
            "regionName": "North America",
            "haystackUrl": "https://silo.dev.service.75f.io/",
            "siteSequencerUrl": "https://seq-runner.dev.service.75f.io",
            "notesUrl": "https://notes-api.dev.service.75f.io/",
            "filestorageUrl": "https://filestorage.dev.service.75f.io/",
            "equipBuilderUrl": "https://equip-builder.dev.service.75f.io/",
        }
    }
};
